import { UserType } from '@app/framework/constants/user.constants';

export interface PrimeInvitation {
  id: number;
  title: string;
  sub_project_invites: Invitation[];
  prime_project_invitations: Invitation[];
}

export enum INVITATION_STATUS {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DISMISSED = 'dismissed',
  CANCELLED = 'cancelled',
  INVALID = 'invalid', // Not used on backend currently
}

export interface Invitation {
  id: string;
  author_id: number;
  manager_project_id: number;
  prime_project_id: number | null;
  manager_contact_id: number | null;
  sp_contact_id: number;
  manager_user_id: number | null;
  sp_user_id: number | null;
  status: INVITATION_STATUS;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  sp_contact?: InvitationContact; // todo: check if present
  manager_contact?: InvitationContact; // todo: check if present
  contact?: InvitationContact; // todo: check if always present
}

export interface InvitationContact {
  id: number;
  group_id: number;
  email: string;
  title: string;
  first_name: string;
  last_name: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  deleted_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface InvitationsState {
  isLoading: boolean;
  invitationGroups: PrimeInvitation[];
  invitationsReceived: InvitationReceivedExtended[];
  invitationBeingAccepted: InvitationReceivedExtended;
  searchText: string | null;
}

export interface DisplayInvitationGroup {
  id: number;
  name: string;
  initials: string;
  invitations: DisplayInvitation[];
}
export interface DisplayInvitation {
  id: string;
  name: string;
  email: string;
  title: string;
  initials: string;
  status: INVITATION_STATUS;
  isPrime: boolean;
}

export type PrimeInviteGCPayload = {
  manager_project_id: number;
  sp_contact_id: number;
};

export type PrimeInviteManagerPayload = {
  prime_project_id: number;
  manager_contact_id: number;
};

export type UserInvited = {
  id: number;
  email: string;
  name: string;
  company_name: string;
  type: UserType;
  has_approved_contracts: boolean;
};

export type InvitationReceived = {
  id: string;
  project: {
    custom_project_id: string;
    title: string;
    start_date: string;
  };
  user: {
    email: string;
    name: string;
    company_name: string;
  };
};

export type InvitationReceivedExtended = InvitationReceived & {
  isPrime: boolean;
};

export type InviteForOption = 'prime_contract' | 'commitment' | 'no-commitment';
export type InviteModel = {
  project_id: number;
  contact_id: number;
  invite_for: InviteForOption;
};
